

<script>
const defaultProps = {
  showIcon: true,
  defaultExpandAll: true,
  blockNode: true,
};

export default {
  name: "TreeExpand",
  props: {
    treeProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    treeEvents: {
      type: Object,
      default: () => {
        return {};
      },
    },
    treeClass: {
      type: [String, Object, Array],
      default: () => "",
    },
    treeStyle: {
      type: [String, Object, Array],
      default: () => "",
    },
    rest: {
      type: Object,
      default: () => ({}),
    },
    menus: {
      type: Array,
      default: () => [],
    },
    ellip: {
      type: Object,
      default: () => ({
        show: false,
        length: 0,
      }),
    },
  },
  data() {
    return {
      input: {},
      inputId: null,
      renderTree: true,
    };
  },
  methods: {
    endRename(e) {
      const value = e.target.value;

      if (value == this.input.title) return (this.inputId = null);
      let data;

      try {
        data = {
          authorityId: this.input.data.authorityId,
          id: this.input.id,
          name: value,
          parentAllPath: this.input.data.allPath,
          parentId: this.input.parentId,
          isSetting: 1,
        };
      } catch (err) {
        data = {};
      }

      this.$emit("rename", value, data);
      this.inputId = null;
    },
    onRename(context) {
      this.input = context;
      this.inputId = context.id || context.key;
    },
    clickMenu(menu, context) {
      menu.on && menu.on.click && menu.on.click(context);
    },
  },
  watch: {
    // 强制刷新
    treeProps: {
      deep: true,
      handler(val) {
        this.renderTree = false;
        this.$nextTick(() => (this.renderTree = true));
      },
    },
  },
  render(h) {
    const props = {
      ...defaultProps,
      ...this.treeProps,
      checkedKeys: this.checkedKeys,
    };

    // console.log(props,'props')

    const renderMenuItems = (context, excludes) =>
      this.menus
        .filter((menu) => !excludes.has(this.$t(menu.title)))
        .map((menu, index) => {
          return (
            <a-menu-item key={index}>
              <a onClick={() => this.clickMenu(menu, context)}>
                {this.$t(menu.title)}
              </a>
            </a-menu-item>
          );
        });

    const renderTemplate = (context) => {

      console.log(context,'查看数据',this.treeProps,props)
      const excludes = new Set(context.excludes);

      const show = (
        <div>
          {this.ellip.show ? (
            <ellipsis length={this.ellip.length} tooltip={true}>
              {context.title}
            </ellipsis>
            
          ) : (
            <span>{context.title}</span>
          )}
          <a-dropdown>
            <a class="right-drop-down" onClick={(e) => e.stopPropagation()}>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">{renderMenuItems(context, excludes)}</a-menu>
          </a-dropdown>

          {context.expanded ? (

            context.children ? (
              <a-icon v-if='context.children' type="folder-open" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
            ) : ''

          ) : (
            context.children ? (
              <a-icon type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
            ) : ''
            
          )}

          

        </div>
      );
      const input = (
        <a-input
          size="small"
          autoFocus={true}
          defaultValue={context.title}
          onBlur={this.endRename}
        ></a-input>
      );
      return (context.id || context.key) === this.inputId ? input : show;
    };

    const renderTemplateIcon = (context) => {
      console.log(context.id,'查看数据')
      const icon = (
        <a-icon type="folder" theme='filled' style='color: rgba(74,144,226,0); font-size: 20px; position: relative; z-index: 99;'/>
      );
      return icon;
    };

    const tree = this.renderTree
      ? h("a-tree", {
          props: props,
          scopedSlots: {
            custom: (context) => renderTemplate(context),
            switcherIcon: (context) => renderTemplateIcon(context),
          },
          on: {
            ...this.treeEvents,
          },
          class: this.treeClass,
          style: this.treeStyle,
          ...this.rest,
        })
      : null;

    return <div class="wrapper">{tree}</div>;
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  .right-drop-down {
    display: none;
    float: right;
    width: 40px;
    text-align: center;
  }

  /deep/ .ant-tree-treenode-selected > span .right-drop-down {
    display: block !important;
  }

  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg {
    transform: rotate(0deg)!important;
  }

  /deep/ .ant-tree-title {
    position: relative;
  }

  /deep/ .ant-tree-switcher {
    color: rgba(0, 0, 0, 0)!important;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: rgb(255, 241, 184);
  }
}
</style>
